import {Box, Center, Flex, Icon, Image, Text} from '@chakra-ui/react'
import Tabs from './Tabs'
import Suggest from './Suggest'
import TabContent1 from './TabContent1'
import {useEffect, useRef, useState} from 'react'
import Header from './Header'
import BandScore from './BandScore'
import TabContent2 from './TabContent2'
import ScrollTab from './ScrollTab'
import StatusPhrase from './StatusPhrase'
import examRequest from '@apis/exam'
import ControlAudio from './ControlAudio'
import {useDispatch, useSelector} from 'react-redux'
import {
  updateAudioClips,
  updateDataExamResult,
  updateExamResultPart,
  updateTabScrollValue,
} from '@redux/exam-result/examResult'
import WarningIcon from '@assets/svgs/exam/warming.svg'
import {ReactComponent as BackToHomeIcon} from '@assets/svgs/exam/back-to-home.svg'
import {useLocation, useNavigate} from 'react-router-dom'
import './index.css'
import {PATH} from '@utils/Const'

const ExamResult = () => {
  const {dataExamResult, examResultPart, tabValue, tabScrollValue, audioTime} =
    useSelector((state: any) => state.examResult)
  const [isLoading, setIsLoading] = useState(true)
  const audioRef = useRef<any>(null)
  const dispatch = useDispatch()
  const location = useLocation()
  const navigate = useNavigate()
  const session_id = location.state?.session_id
  let requestAgain = true

  useEffect(() => {
    if (!session_id) return
    getExamResult()
  }, [])

  useEffect(() => {
    if (!dataExamResult) {
      return
    }
    const UpdateAudioClips = dataExamResult?.transcript_review?.transcripts.map(
      (question: any, questionIndex: any) => {
        let duration = 0,
          start_time = 0

        if (questionIndex === 0) {
          start_time = 0
          duration = question.end_time
        } else if (
          questionIndex ===
          dataExamResult?.transcript_review?.transcripts.length - 1
        ) {
          start_time = question.start_time
          duration = audioTime?.duration - question.start_time
        } else {
          start_time = question.start_time
          duration =
            dataExamResult?.transcript_review?.transcripts[questionIndex + 1]
              .start_time - question.start_time
        }
        return {
          start_time,
          duration,
        }
      },
    )
    dispatch(updateAudioClips(UpdateAudioClips))
  }, [dataExamResult, audioTime?.duration])

  const getExamResult = async () => {
    setIsLoading(true)

    try {
      const res = await examRequest.getExamResultDetail(session_id)
      if (res.status === 200) {
        const feedbackPart = [
          {type: 'overview', display: 'Tổng quan'},
          ...res.data.data.feedback_parts,
        ]
        dispatch(updateExamResultPart(feedbackPart))
        dispatch(updateDataExamResult(res.data.data))
      }
      setIsLoading(false)
    } catch (error) {
      if (requestAgain) {
        getExamResult()
        requestAgain = false
      } else {
        setIsLoading(false)
      }
    }
  }

  const handleScroll = () => {
    const scrollElement = document.querySelector('.exam-result-scroll-tab')
    examResultPart.forEach((item: any) => {
      const itemPart = document.querySelector(`.${item.type}`)
      if (!itemPart) return
      if (isInViewport(itemPart, scrollElement)) {
        dispatch(updateTabScrollValue(item.type))
      }
    })
  }

  const isInViewport = (child: any, parent: any) => {
    const childRect = child.getBoundingClientRect()
    const parentRect = parent.getBoundingClientRect()
    return (
      (childRect.top >= parentRect.top &&
        childRect.left >= parentRect.left &&
        childRect.bottom <= parentRect.bottom &&
        childRect.right <= parentRect.right) ||
      (childRect.top <= parentRect.top &&
        childRect.bottom >= parentRect.bottom) ||
      (childRect.top <= parentRect.bottom - 160 &&
        childRect.bottom >= parentRect.bottom)
    )
  }

  if (!session_id) {
    return (
      <Center
        minH={'100vh'}
        bg={'#F0F6FD'}
        flexDirection={'column'}
        gap={'24px'}
        p={'20px'}>
        <Box textAlign="center" maxW="400px">
          <Text fontSize={'20px'} fontWeight={600} color={'#2D3748'} mb={'8px'}>
            Bạn chưa học phần nào!
          </Text>
          <Text fontSize={'14px'} color={'#718096'} mb={'16px'}>
            Hãy bắt đầu bài thi của bạn ngay bây giờ
          </Text>
        </Box>

        <Flex
          role="group"
          p={'14px 24px'}
          borderRadius={'40px'}
          bg={'white'}
          alignItems={'center'}
          cursor={'pointer'}
          boxShadow={'0 2px 8px rgba(0,0,0,0.06)'}
          transition="all 0.2s"
          _hover={{
            transform: 'translateY(-2px)',
            boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
          }}
          onClick={() => navigate(PATH.EXAM)}>
          <Icon
            w={'20px'}
            h={'20px'}
            sx={{
              stroke: '#1F1F1F',
            }}
            _groupHover={{
              stroke: '#003D75',
            }}>
            <BackToHomeIcon />
          </Icon>
          <Text
            fontSize={'16px'}
            fontWeight={500}
            color={'#1F1F1F'}
            pl={'12px'}
            _groupHover={{
              color: '#003D75',
            }}>
            Về trang thi
          </Text>
        </Flex>
      </Center>
    )
  }

  if (isLoading) {
    return (
      <Center minH={'100vh'} bg={'#F0F6FD'}>
        <Flex gap={'16px'} alignItems={'center'}>
          <Box className="loader-exam-result"></Box>
          <Text fontSize={'16px'} fontWeight={600}>
            Đang xử lý dữ liệu...
          </Text>
        </Flex>
      </Center>
    )
  }

  if (!dataExamResult) {
    return (
      <Center
        minH={'100vh'}
        bg={'#F0F6FD'}
        flexDirection={'column'}
        gap={'16px'}>
        <Image src={WarningIcon} w={'64px'} h={'64px'} />
        <Text fontSize={'16px'} fontWeight={600}>
          Hệ thống đang gặp sự cố, bạn thử lại sau nhé!
        </Text>
      </Center>
    )
  }

  return (
    <Box minH={'100vh'} bg={'#F0F6FD'} p={{base: '16px', md: '32px'}}>
      <Center
        role="group"
        p={'12px'}
        borderRadius={'40px'}
        bg={'white'}
        h={'48px'}
        position={'absolute'}
        right={'20px'}
        top={'20px'}
        cursor={'pointer'}
        zIndex={1}
        boxShadow={'0 2px 8px rgba(0,0,0,0.06)'}
        onClick={() => navigate(PATH.EXAM)}>
        <Icon
          w={'24px'}
          h={'24px'}
          sx={{
            stroke: '#1F1F1F',
          }}
          _groupHover={{
            stroke: '#003D75',
          }}>
          <BackToHomeIcon />
        </Icon>
        <Text
          w={'0px'}
          overflow={'hidden'}
          fontSize={'16px'}
          fontWeight={500}
          transition={'0.3s'}
          _groupHover={{
            display: 'block',
            color: '#003D75',
            w: '110px',
            pl: '10px',
          }}
          sx={{textWrap: 'nowrap'}}>
          Về trang thi
        </Text>
      </Center>
      <Box maxW={'1280px'} mx={'auto'}>
        <Header />
        <BandScore />
        <Box mt={{base: '16px', md: '32px'}} position={'relative'}>
          <Tabs />
          <Box
            className="exam-result-scroll-tab"
            scrollBehavior={'smooth'}
            bg={'white'}
            p={{base: '16px', md: '40px'}}
            pt={{base: '0px', md: '0px'}}
            borderRadius={'16px'}
            maxH={'600px'}
            overflow={'auto'}
            style={{
              scrollbarWidth: 'none',
            }}
            onScroll={handleScroll}>
            <Box
              p={'16px 0px 16px 0px'}
              position={'sticky'}
              top={0}
              zIndex={2}
              bg={'white'}>
              <ScrollTab audioRef={audioRef} />
            </Box>
            {tabValue === 1 && <TabContent1 audioRef={audioRef} />}
            {tabValue === 2 && <TabContent2 />}
            <Box
              pointerEvents={
                tabValue === 1 && tabScrollValue !== 'overview'
                  ? 'unset'
                  : 'none'
              }
              opacity={tabValue === 1 && tabScrollValue !== 'overview' ? 1 : 0}
              transition={'0.3s'}>
              <StatusPhrase />
            </Box>
          </Box>
          <Box
            h={'80px'}
            w={'100%'}
            borderTop={'1px solid #D9D9D9'}
            borderRadius={'0px 0px 16px 16px'}
            bg={'white'}
            position={'absolute'}
            bottom={0}
            pointerEvents={
              tabValue === 1 && tabScrollValue !== 'overview' ? 'unset' : 'none'
            }
            opacity={tabValue === 1 && tabScrollValue !== 'overview' ? 1 : 0}
            transition={'0.3s'}>
            <ControlAudio audioRef={audioRef} />
          </Box>
        </Box>
        <Suggest />
      </Box>
    </Box>
  )
}

export default ExamResult
